import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Card from 'react-bootstrap/Card';
import InvoiceItem from './InvoiceItem';
import InvoiceModal from './InvoiceModal';
import InputGroup from 'react-bootstrap/InputGroup';

class InvoiceForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      currency: 'INR',
      currencySymbol: '₹',
      language: 'en-IN',
      currentDate: '',
      invoiceNumber: 1,
      ticketId: 0,
      status: 'unpaid',
      dateOfIssue: '',
      dueDate: '',
      createdAt: '',
      updatedAt: '',
      orderCategory: 'subscription',
      viewPermission: 'owner_admin',
  
      // Billing Details
      billFrom: '',
      billFromEmail: '',
      billFromAddress: '',
      billFromPhone: '',
      billFromTaxId: '',
      
      billTo: '',
      billToEmail: '',
      billToAddress: '',
      billToPhone: '',
      billToTaxId: '',
  
      billedBy: {
        userId: '',
        username: '',
        role: ''
      },
  
      // Invoice Items
      items: [
        {
          id: 0,
          name: '',
          description: '',
          unit: 'license',
          unitPrice: '1.00',
          quantity: 1,
          discount: {
            type: '',
            value: 0
          },
          tax: {
            rate: 0,
            amount: 0
          },
          total: 0
        }
      ],
  
      // Totals
      subTotal: '0.00',
      taxRate: '',
      taxAmount: '0.00',
      discountRate: '',
      discountAmount: '0.00',
      shippingCost: 0,
      total: '0.00',
  
      // Currency Conversion
      currencyConversion: {
        base: 'INR',
        target: 'USD',
        rate: 0,
        convertedTotal: 0
      },
  
      // Payment
      payment: {
        method: '',
        status: 'pending',
        transactionId: '',
        paidOn: ''
      },
  
      // Recurring Settings
      recurring: {
        isRecurring: false,
        frequency: '',
        startDate: '',
        endDate: '',
        autoCharge: false,
        nextInvoiceDate: ''
      },
  
      // Signatures
      signatures: {
        clientSignature: {
          signed: false,
          signedAt: '',
          signatureUrl: ''
        }
      },
  
      // Attachments
      attachments: [],
  
      // Custom Fields
      customFields: {

      },
  
      // Tags
      tags: [],
  
      // Version History
      versionHistory: [
        {
          version: 1,
          updatedAt: '',
          changes: ''
        }
      ],
  
      // Integrations
      integrations: {
        quickbooks: {
          synced: false,
          lastSynced: '',
          externalId: ''
        },
        salesforce: {
          leadId: ''
        }
      },
  
      // Compliance
      compliance: {
        dataRetentionYears: 7,
        gdprConsent: true,
        eInvoiceCompliant: true
      },
  
      // Access Logs
      accessLogs: [],
  
      // Geo Info
      geo: {
        createdFrom: {
          ip: '',
          location: ''
        },
        billedToLocation: {
          lat: null,
          lng: null
        }
      },
  
      // Reminders
      reminderSettings: {
        enabled: false,
        schedule: [
          { daysBeforeDue: 3, method: 'email' },
          { daysAfterDue: 1, method: 'sms' }
        ]
      },
  
      // Notes & Terms
      notes: '',
      terms: 'Due within 7 days. A 2% late fee may apply.',
  
      // History
      history: [
        // {
        //   action: 'created',
        //   timestamp: '',
        //   byUser: ''
        // }
      ]
    };
    this.state.items = [
      {
        id: 0,
        name: '',
        description: '',
        price: '1.00',
        quantity: 1
      }
    ];
    this.editField = this.editField.bind(this);
  }
  componentDidMount(prevProps) {
    this.handleCalculateTotal()
  }
  handleRowDel(items) {
    var index = this.state.items.indexOf(items);
    this.state.items.splice(index, 1);
    this.setState(this.state.items);
  };
  handleAddEvent(evt) {
    var id = (+ new Date() + Math.floor(Math.random() * 999999)).toString(36);
    var items = {
      id: id,
      name: '',
      price: '1.00',
      description: '',
      quantity: 1
    }
    this.state.items.push(items);
    this.setState(this.state.items);
  }
  handleCalculateTotal() {
    var items = this.state.items;
    var subTotal = 0;

    items.map(function(items) {
      subTotal = parseFloat(subTotal + (parseFloat(items.price).toFixed(2) * parseInt(items.quantity))).toFixed(2)
    });

    this.setState({
      subTotal: parseFloat(subTotal).toFixed(2)
    }, () => {
      this.setState({
        taxAmmount: parseFloat(parseFloat(subTotal) * (this.state.taxRate / 100)).toFixed(2)
      }, () => {
        this.setState({
          discountAmount: parseFloat(parseFloat(subTotal) * (this.state.discountRate / 100)).toFixed(2)
        }, () => {
          this.setState({
            total: ((subTotal - this.state.discountAmount) + parseFloat(this.state.taxAmmount))
          });
        });
      });
    });

  };
  onItemizedItemEdit(evt) {
    var item = {
      id: evt.target.id,
      name: evt.target.name,
      value: evt.target.value
    };
    var items = this.state.items.slice();
    var newItems = items.map(function(items) {
      for (var key in items) {
        if (key == item.name && items.id == item.id) {
          items[key] = item.value;
        }
      }
      return items;
    });
    this.setState({items: newItems});
    this.handleCalculateTotal();
  };
  editField = (event) => {
    const { name, value } = event.target;
    const keys = name.split(".");
  
    if (keys.length === 2) {
      const [parentKey, childKey] = keys;
  
      this.setState(prevState => ({
        [parentKey]: {
          ...prevState[parentKey],
          [childKey]: value
        }
      }), this.handleCalculateTotal); // Call after setState
    } else {
      this.setState({
        [name]: value
      }, this.handleCalculateTotal); // Call after setState
    }
  };

  onCurrencyChange = (value) => {
    const [currencySymbol, currency] = value.split('|');
    this.setState({ currencySymbol, currency });
  };
  onSelectChange = (selectedOption) => {
    this.setState(selectedOption);
  };

  openModal = (event) => {
    event.preventDefault()
    this.handleCalculateTotal()
    this.setState({isOpen: true})
  };
  closeModal = (event) => this.setState({isOpen: false});
  render() {
    return (<div className='container'><Form onSubmit={this.openModal}>
      <Row>
  <Col md={8} lg={9}>
    <Card className="p-4 p-xl-5 my-3 my-xl-4">
      <div className="d-flex flex-row align-items-start justify-content-between mb-3">
        <div className="d-flex flex-column">
          {/* <div className="d-flex flex-column">
            <div className="mb-2">
              <span className="fw-bold"><i className="bi bi-calendar4-event"></i> Current Date:&nbsp;</span>
              <span className="current-date">{new Date().toLocaleDateString()}</span>
            </div>
          </div> */}
          <div className="d-flex flex-row align-items-center">
            <span className="fw-bold d-block me-2"><i className="bi bi-calendar2-event-fill"></i> Due Date:</span>
            <Form.Control type="date" value={this.state.dateOfIssue} name="dateOfIssue" onChange={(event) => this.editField(event)} style={{ maxWidth: '150px' }} required />
          </div>
        </div>
        <div className="d-flex flex-row align-items-center">
          <span className="fw-bold me-2"><i className="bi bi-receipt"></i> Invoice Number:&nbsp;</span>
          <Form.Control type="number" value={this.state.invoiceNumber} name="invoiceNumber" onChange={(event) => this.editField(event)} min="1" style={{ maxWidth: '70px' }} required />
        </div>
      </div>
      <br/>
      {/* <hr className="mb-4" /> */}
      <Row className="mb-2">
        <Col>
          <Form.Label className="fw-bold"><i className="bi bi-person-lines-fill"></i> Bill to:</Form.Label>
          <Form.Control placeholder="Who is this invoice to?" rows={3} value={this.state.billTo} type="text" name="billTo" className="mb-2" onChange={(event) => this.editField(event)} autoComplete="name" required />
            <Row>
              <Col><Form.Control placeholder="Email address" value={this.state.billToEmail} type="email" name="billToEmail" className="mb-2" onChange={(event) => this.editField(event)} autoComplete="email" required /></Col>
              <Col><Form.Control placeholder="Phone number" value={this.state.billToPhone} type="tel" name="billToPhone" className="mb-2" onChange={(event) => this.editField(event)} /></Col></Row>
          
          <Form.Control placeholder="Billing address" value={this.state.billToAddress} type="text" name="billToAddress" className="mb-2" autoComplete="address" onChange={(event) => this.editField(event)} required />

          <Form.Control placeholder="Tax ID" value={this.state.billToTaxId} type="text" name="billToTaxId" className="mb-2" onChange={(event) => this.editField(event)} />
        </Col>
        <Col>
          <Form.Label className="fw-bold"><i className="bi bi-person-fill"></i> Bill from:</Form.Label>
          <Form.Control placeholder="Who is this invoice from?" rows={3} value={this.state.billFrom} type="text" name="billFrom" className="mb-2" onChange={(event) => this.editField(event)} autoComplete="name" required />
          
           <Row>
            <Col><Form.Control placeholder="Email address" value={this.state.billFromEmail} type="email" name="billFromEmail" className="mb-2" onChange={(event) => this.editField(event)} autoComplete="email" required /></Col>
            <Col><Form.Control placeholder="Phone number" value={this.state.billFromPhone} type="tel" name="billFromPhone" className="mb-2" onChange={(event) => this.editField(event)} /></Col></Row> 
          <Form.Control placeholder="Billing address" value={this.state.billFromAddress} type="text" name="billFromAddress" className="mb-2" autoComplete="address" onChange={(event) => this.editField(event)} required />
          
          <Form.Control placeholder="Tax ID" value={this.state.billFromTaxId} type="text" name="billFromTaxId" className="mb-2" onChange={(event) => this.editField(event)} />
        </Col>
      </Row>
   
      <br/>
      <Row className="mb-2">
      <Col>
      <Form.Label className="fw-bold"><i className="bi bi-credit-card"></i> Payment Info:</Form.Label>
      <Row>
        <Col><Form.Control placeholder="Payment Method" value={this.state.payment.method} type="text" name="payment.method" className="mb-2" onChange={(event) => this.editField(event)} /></Col>
        <Col><Form.Control placeholder="Transaction ID" value={this.state.payment.transactionId} type="text" name="payment.transactionId" className="mb-2" onChange={(event) => this.editField(event)} /></Col>
        </Row>

      </Col>
      </Row>
      <br/>

   
      <InvoiceItem onItemizedItemEdit={this.onItemizedItemEdit.bind(this)} onRowAdd={this.handleAddEvent.bind(this)} onRowDel={this.handleRowDel.bind(this)} currency={this.state.currencySymbol} items={this.state.items} />
      <br/>
      <Row className="mt-2 justify-content-end">
        <Col lg={5}>
          <div className="d-flex flex-row align-items-start justify-content-between">
            <span className="fw-bold">Subtotal:</span>
            <span>{this.state.currencySymbol}{this.state.subTotal}</span>
          </div>
          <div className="d-flex flex-row align-items-start justify-content-between mt-2">
            <span className="fw-bold">Discount:</span>
            <span><span className="small">({this.state.discountRate || 0}%)</span> {this.state.currencySymbol}{this.state.discountAmount || 0}</span>
          </div>
          <div className="d-flex flex-row align-items-start justify-content-between mt-2">
            <span className="fw-bold">Tax:</span>
            <span><span className="small">({this.state.taxRate || 0}%)</span> {this.state.currencySymbol}{this.state.taxAmount || 0}</span>
          </div>
          <hr />
          <div className="d-flex flex-row align-items-start justify-content-between" style={{ fontSize: '1.125rem' }}>
            <span className="fw-bold">Total:</span>
            <span className="fw-bold">{this.state.currencySymbol}{this.state.total || 0}</span>
          </div>
        </Col>
      </Row>
 

      {/* <hr className="mb-4" /> */}

     
   

      <br/>
     
      <Form.Label className="fw-bold"><i className="bi bi-card-text"></i> Notes:</Form.Label>
      <Form.Control placeholder="Thanks for your business!" name="notes" value={this.state.notes} onChange={(event) => this.editField(event)} as="textarea" className="mb-2" rows={1} />
      <Form.Label className="fw-bold"><i className="bi bi-journal-text"></i> Terms:</Form.Label>
      <Form.Control name="terms" value={this.state.terms} onChange={(event) => this.editField(event)} as="textarea" className="mb-2" rows={2} />

      {/* <Form.Group className="my-3">
        <Form.Check 
          type="switch"
          id="recurring-switch"
          label="Recurring Invoice"
          checked={this.state.recurring.isRecurring}
          onChange={(e) => this.editField({ target: { name: 'recurring.isRecurring', value: e.target.checked } })}
        />
        {this.state.recurring.isRecurring && (
          <>
            <Form.Control placeholder="Frequency (e.g., monthly)" value={this.state.recurring.frequency} name="recurring.frequency" onChange={(event) => this.editField(event)} className="mb-2" />
            <Form.Control type="date" value={this.state.recurring.startDate} name="recurring.startDate" onChange={(event) => this.editField(event)} className="mb-2" />
            <Form.Control type="date" value={this.state.recurring.endDate} name="recurring.endDate" onChange={(event) => this.editField(event)} className="mb-2" />
            <Form.Check 
              type="checkbox"
              label="Auto-charge"
              checked={this.state.recurring.autoCharge}
              onChange={(e) => this.editField({ target: { name: 'recurring.autoCharge', value: e.target.checked } })}
            />
          </>
        )}
      </Form.Group> */}
    </Card>
  </Col>
  <Col md={4} lg={3}>
    <div className="sticky-top pt-md-3 pt-xl-4">
      <Button variant="dark" type="submit" className="d-block pop w-100"><i className="bi bi-search"></i> Review Invoice</Button>
      <InvoiceModal showModal={this.state.isOpen} closeModal={this.closeModal} info={this.state} items={this.state.items} currency={this.state.currencySymbol} subTotal={this.state.subTotal} taxAmmount={this.state.taxAmount} discountAmount={this.state.discountAmount} total={this.state.total} />
     

      <Form.Group className="mb-3">
        <Form.Label className="fw-bold"><i className="bi bi-check2-circle"></i> Order Status:</Form.Label>
        <Form.Select onChange={event => this.onSelectChange({ status: event.target.value })} className="btn bg-white border my-1" aria-label="Change Status">
                <option value="unpaid">Unpaid</option>
                <option value="paid">Paid</option>
                <option value="overdue">Overdue</option>
                <option value="cancelled">Cancelled</option>
                <option value="refunded">Refunded</option>
        </Form.Select>
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label className="fw-bold"><i className="bi bi-cash-coin"></i> Currency:</Form.Label>
        <Form.Select
  onChange={(event) => this.onCurrencyChange(event.target.value)}
  className="btn bg-white border my-1"
  aria-label="Change Currency"
>
  <option value="₹|INR">INR (Indian Rupee)</option>
  <option value="$|USD">USD (United States Dollar)</option>
  <option value="€|EUR">EUR (Euro)</option>
  <option value="£|GBP">GBP (British Pound Sterling)</option>
  <option value="₭|AED">AED (UAE Dirham)</option>
  <option value="¥|JPY">JPY (Japanese Yen)</option>
  <option value="$|CAD">CAD (Canadian Dollar)</option>
  <option value="$|AUD">AUD (Australian Dollar)</option>
  <option value="$|SGD">SGD (Singapore Dollar)</option>
  <option value="¥|CNY">CNY (Chinese Renminbi)</option>
  <option value="₩|KRW">KRW (South Korean Won)</option>
  <option value="₺|TRY">TRY (Turkish Lira)</option>
</Form.Select>
      </Form.Group>
      <Form.Group className="my-3">
        <Form.Label className="fw-bold"><i className="bi bi-calculator"></i> Tax Rate:</Form.Label>
        <InputGroup className="my-1 flex-nowrap">
          <Form.Control name="taxRate" type="number" value={this.state.taxRate} onChange={(event) => this.editField(event)} className="bg-white border" placeholder="0.0" min="0.00" step="0.01" max="100.00" />
          <InputGroup.Text className="bg-light fw-bold text-secondary small">%</InputGroup.Text>
        </InputGroup>
      </Form.Group>
      <Form.Group className="my-3">
        <Form.Label className="fw-bold"><i className="bi bi-percent"></i> Discount Rate:</Form.Label>
        <InputGroup className="my-1 flex-nowrap">
          <Form.Control name="discountRate" type="number" value={this.state.discountRate} onChange={(event) => this.editField(event)} className="bg-white border" placeholder="0.0" min="0.00" step="0.01" max="100.00" />
          <InputGroup.Text className="bg-light fw-bold text-secondary small">%</InputGroup.Text>
        </InputGroup>
      </Form.Group>

      <Form.Group className="my-3">
        <Form.Label className="fw-bold"><i className="bi bi-ticket"></i> Ticket Id:</Form.Label>
        <InputGroup className="my-1 flex-nowrap">
          <Form.Control name="ticketId" type="number" value={this.state.ticketId} onChange={(event) => this.editField(event)} className="bg-white border" placeholder="0" min="0" step="1"  />
        </InputGroup>
      </Form.Group>
   
     
    </div>
  </Col>
</Row>

    </Form></div>)
  }
}

export default InvoiceForm;
